export const systemSetting = [
  {
    path: '/systemSetting/baseInfo',
    component: () => import(/* webpackChunkName: "systemSettingBaseInfo" */ '@/views/systemSetting/baseInfo')
  },
  {
    path: '/systemSetting/baseInfo/trace',
    component: () => import(/* webpackChunkName: "systemSettingTrack" */ '@/views/systemSetting/trace')
  },

  {
    path: '/systemSetting/manage/user',
    component: () => import(/* webpackChunkName: "systemSettingUser" */ '@/views/systemSetting/user/user')
  },
  {
    path: '/systemSetting/manage/rolePower',
    component: () => import(/* webpackChunkName: "systemSettingRolePower" */ '@/views/systemSetting/user/rolePower')
  },
  {
    path: '/systemSetting/manage/rolePower/data',
    component: () => import(/* webpackChunkName: "systemSettingRolePowerData" */ '@/views/systemSetting/user/dataPower')
  },
  {
    path: '/systemSetting/manage/rolePower/menu',
    component: () => import(/* webpackChunkName: "systemSettingRolePowerMenu" */ '@/views/systemSetting/user/menuPower')
  },
  {
    path: '/systemSetting/manage/menuPower',
    component: () => import(/* webpackChunkName: "systemSettingMenuPower" */ '@/views/systemSetting/system/menuPower')
  },
  {
    path: '/systemSetting/manage/projectProgress',
    component: () => import(/* webpackChunkName: "systemSettingProjectProgress" */ '@/views/systemSetting/project/projectProgress')
  },
  {
    path: '/systemSetting/manage/sector',
    component: () => import(/* webpackChunkName: "systemSettingSector" */ '@/views/systemSetting/project/sector')
  },
  {
    path: '/systemSetting/manage/documentType',
    component: () => import(/* webpackChunkName: "systemSettingDocumentType" */ '@/views/systemSetting/project/documentType')
  },
  {
    path: '/systemSetting/manage/round',
    component: () => import(/* webpackChunkName: "systemSettingRound" */ '@/views/systemSetting/project/round')
  },
  {
    path: '/systemSetting/manage/projectTags/:type',
    component: () => import(/* webpackChunkName: "systemSettingProject" */ '@/views/systemSetting/project/projectTags')
  },
  {
    path: '/systemSetting/notice',
    component: () => import(/* webpackChunkName: "systemSettingNotice" */ '@/views/systemSetting/system/notice')
  },
  {
    path: '/systemSetting/opLog',
    component: () => import(/* webpackChunkName: "systemSettingOplog" */ '@/views/systemSetting/system/opLog')
  },
  {
    path: '/systemSetting/manage/departmentRole',
    component: () => import(/* webpackChunkName: "systemSettingDepartment" */ '@/views/systemSetting/user/departmentRole')
  },
  {
    path: '/systemSetting/manage/strategyTag',
    component: () => import(/* webpackChunkName: "systemSettingStrategyTag" */ '@/views/systemSetting/project/strategyTag')
  },
  {
    path: '/systemSetting/manage/strategyTagRelation',
    component: () => import(/* webpackChunkName: "systemSettingStrategyRelation" */ '@/views/systemSetting/project/strategyTagRelation')
  },
  {
    path: '/systemSetting/manage/coin',
    component: () => import(/* webpackChunkName: "systemSettingProjectQuality" */ '@/views/systemSetting/operate/coin/index')
  },
  {
    path: '/systemSetting/manage/createCoin',
    component: () => import(/* webpackChunkName: "systemSettingProjectQuality" */ '@/views/systemSetting/operate/coin/create')
  },
  {
    path: '/systemSetting/manage/projectQuality',
    component: () => import(/* webpackChunkName: "systemSettingProjectQuality" */ '@/views/systemSetting/operate/qualityManage')
  },
  {
    path: '/systemSetting/manage/projectQuality/createQuality',
    component: () => import(/* webpackChunkName: "systemSettingCreateQuality" */ '@/views/systemSetting/operate/createQuality')
  },
  {
    path: '/systemSetting/manage/projectContribution',
    component: () => import(/* webpackChunkName: "systemSettingProjectContribution" */ '@/views/systemSetting/operate/projectContribution')
  },
  {
    path: '/systemSetting/manage/financeProjectContribution',
    component: () => import(/* webpackChunkName: "systemSettingFinanceProjectContribution" */ '@/views/systemSetting/operate/financeProjectContribution.vue')
  },
  {
    path: '/systemSetting/manage/financeProjectVote',
    component: () => import(/* webpackChunkName: "systemSettingFinanceProjectContribution" */ '@/views/systemSetting/operate/financeProjectVote.vue')
  },
  {
    path: '/systemSetting/manage/projectContribution/createContribution',
    component: () => import(/* webpackChunkName: "systemSettingCreateContribution" */ '@/views/systemSetting/operate/createContribution')
  },
  {
    path: '/systemSetting/manage/projectMember',
    component: () => import(/* webpackChunkName: "projectMember" */ '@/views/systemSetting/operate/projectMember')
  }
];
